import React, { useEffect } from 'react';
import cn from 'classnames';

import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import updateLocale from 'dayjs/plugin/updateLocale';
import 'dayjs/locale/he';

import type { DatePickerProps } from 'antd';
import { DatePicker as AntdDatePicker } from 'antd';
import heLocale from 'antd/es/date-picker/locale/he_IL';

import { BBModel } from 'types/story';
import { UNIFORM_PROPS } from 'common/constants';
import { getDateFormat } from '../utils';
import { TFieldProps, DateDelimiter, DateFormat } from '../types';
import css from './TextField.scss';

type PickerLocale = Exclude<DatePickerProps['locale'], undefined>;

const heLocaleOverrides: Partial<PickerLocale['lang']> = {
	shortWeekDays: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", 'שבת'],
	shortMonths: ['ינו', 'פבר', 'מרץ', 'אפר', 'מאי', 'יוני', 'יולי', 'אוג', 'ספט', 'אוק', 'נוב', 'דצמ'],
};

dayjs.extend(weekday);
dayjs.extend(updateLocale);
dayjs.updateLocale('en', { weekStart: 1 });
dayjs.updateLocale('he', { weekStart: 0 });

type Props = Pick<TFieldProps, 'className' | 'name' | 'placeholder' | 'data-bb-field'> & Pick<BBModel, 'uiConfig'>;

const DatePicker: React.FC<Props> = props => {
	const [locale, setLocale] = React.useState<PickerLocale | undefined>(undefined);

	useEffect(() => {
		if (document.documentElement.dir === 'rtl') {
			// fixme: chunk load is failed, when story url contains path to card in published url
			//        need to make request always to story root path, but not card directory path
			// import('antd/es/date-picker/locale/he_IL').then(({ default: he }) => {
			// 	setLocale({ ...he, lang: { ...he.lang, ...heLocaleOverrides } });
			// });
			setLocale({ ...heLocale, lang: { ...heLocale.lang, ...heLocaleOverrides } });
		}
	}, []);

	return (
		<AntdDatePicker
			{...props}
			className={cn(css.field, css.datePicker, props.className)}
			transitionName="" // disable in/out animation
			allowClear={false}
			locale={locale}
			format={getDateFormat(
				props.uiConfig.componentProps[UNIFORM_PROPS.dpFormat] ?? DateFormat.DDMMYYYY,
				props.uiConfig.componentProps[UNIFORM_PROPS.dpDelimiter] ?? DateDelimiter['.']
			)}
			suffixIcon={null}
			popupClassName={css.datePickerPopup}
			inputReadOnly
		/>
	);
};

export default DatePicker;
